import React from 'react'
import Icons from '../icons'
import TextField from '../inputs/TextField'

const DynamicInputTable = () => {
  return (
    <div className="w-full border my-4 rounded-lg border-formBorder">
      <table className="w-full ">
        <thead className="bg-primaryExtraLight text-grey-medium font-medium text-xs">
          <tr>
            <td className="py-2.5 px-2 rounded-tl-lg">
              <div className="flex justify-between">
                <span>Rate Code</span>
                <Icons
                  name="sortupdown-icon"
                  className="size-4 cursor-pointer"
                />
              </div>
            </td>
            <td className="py-2.5 px-2">
              <div className="flex justify-between">
                <span>Type</span>
                <Icons
                  name="sortupdown-icon"
                  className="size-4 cursor-pointer"
                />
              </div>
            </td>
            <td className="py-2.5 px-2">
              <div className="flex justify-between">
                <span>Description</span>
                <Icons
                  name="sortupdown-icon"
                  className="size-4 cursor-pointer"
                />
              </div>
            </td>
            <td className="py-2.5 px-2">
              <div className="flex justify-between">
                <span>Rate</span>
                <Icons
                  name="sortupdown-icon"
                  className="size-4 cursor-pointer"
                />
              </div>
            </td>
            <td className="py-2.5 px-2">
              <div className="flex justify-between">
                <span>VAT Rate</span>
                <Icons
                  name="sortupdown-icon"
                  className="size-4 cursor-pointer"
                />
              </div>
            </td>
            <td className="py-2.5 px-2 rounded-tr-lg"></td>
          </tr>
        </thead>
        <tbody className="text-grey-medium">
          <tr>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <Icons name="delete" className="size-4 cursor-pointer" />
            </td>
          </tr>
          <tr>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <Icons name="delete" className="size-4 cursor-pointer" />
            </td>
          </tr>
          <tr>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <TextField id="2" name="" type="text" fullwidth />
            </td>
            <td className="p-2">
              <Icons name="delete" className="size-4 cursor-pointer" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default DynamicInputTable
